import { useTranslation } from "react-i18next";
import { useGetCamTripSummaryQuery } from "../../../api/network/camerasAdminVMApiService";
import { DISTANCE_UNITS } from "../../admin-details/account/constants";
import useConversion from "../../../hooks/conversion";
import { REPORT_FIELD_OUTPUT_TYPES } from "../../reports/constants";
import { convertMetersTo } from "../../../utils/distance";

const TripSummary = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "camera.dashboard.summary",
  });
  const { data: dataTripSummary, isFetching } = useGetCamTripSummaryQuery();
  const { getUnitByOutputType } = useConversion();

  const getSpeedUnit = () => {
    return getUnitByOutputType(REPORT_FIELD_OUTPUT_TYPES.M_TO_DISTANCE_UNITS);
  };

  const getDistance = () => {
    let result = convertMetersTo(
      getSpeedUnit() as DISTANCE_UNITS,
      dataTripSummary?.total_distance_in_m ?? 0
    );
    return result.toFixed(2);
  };

  /**
   * Convert seconds to hours:minutes
   * @param seconds
   */
  const convertSecToHrs = (seconds: number) => {
    if (seconds === 0) return "0:00";
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return `${hours}:${minutes < 10 ? "0" : ""}${minutes}`;
  };

  return (
    <div className="bg-white rounded-lg border-2 shadow-lg h-48 grid grid-cols-12 p-4 gap-1">
      <h1 className="font-semibold text-lg leading-5 tracking-tight align-middle col-span-12">
        {t("trip_summary")}
      </h1>
      <div className="col-span-12 place-content-left">
        <h1 className="font-semibold text-sm leading-5 tracking-tight align-middle">
          {t("total_trips")}
        </h1>
        <h1 className="text-blue-500 text-2xl font-bold">
          {dataTripSummary?.total_trips ?? 0}
        </h1>
      </div>
      <div className="col-span-6">
        <h1 className="font-semibold text-sm leading-5 tracking-tight align-middle">
          {getSpeedUnit() === DISTANCE_UNITS.MILES
            ? t("driving_distance_miles")
            : getSpeedUnit() === DISTANCE_UNITS.NAUTICAL_MILES
              ? t("driving_distance_nm")
              : t("driving_distance_kms")}
        </h1>
        <h1 className="text-blue-500 text-2xl font-bold">{getDistance()}</h1>
      </div>
      <div className="col-span-6">
        <h1 className="font-semibold text-sm leading-5 tracking-tight align-middle">
          {t("driving_time")}
        </h1>
        <h1 className="text-blue-500 text-2xl font-bold">
          {convertSecToHrs(dataTripSummary?.total_duration_in_sec ?? 0)}
        </h1>
      </div>
    </div>
  );
};

export default TripSummary;
